@use '../@shared/global' as *;

@layer kol-component {
	.kol-headline {
		&--secondary {
			margin: 0;
		}
	}
}
